export default __webpack_public_path__ + "static/media/field.a8d39427.svg";